import React, { useEffect, useState } from "react";

// ──────────────────────────────────────────────
// PcAppInstall.jsx — loginHS PC 앱(윈도 트레이) 내려받기 칸 (2026-10-06)
//   설치 안내(?page=install)를 윈도 PC 에서 열면 맨 위에 보인다. 트레이 앱 안에서 연 화면이면 숨긴다.
//   설치 파일: GET /api/onto/memo/agent(정보) → /api/onto/memo/agent/download (로그인 없이, 비밀 아님)
// ──────────────────────────────────────────────

const INK = "#16151a";
const MUTED = "#6b7280";
const BODY = "#4b5563";
const LINE = "#ecedf2";
const BLUE = "#1a56db";

export function isWindowsDesktop(ua = (typeof navigator !== "undefined" && navigator.userAgent) || "") {
  return /Windows NT/i.test(ua) && !/Mobile/i.test(ua);
}

export function inTrayApp() {
  try { return localStorage.getItem("loginhs:in-agent") === "1"; } catch { return false; }
}

function formatBytes(n) {
  if (!n) return "";
  return n >= 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)}MB` : `${Math.round(n / 1024)}KB`;
}

const Key = ({ children }) => (
  <span style={{ display: "inline-block", border: `1px solid ${LINE}`, borderRadius: 4, padding: "0 5px", fontSize: 12, background: "#f7f8fa" }}>{children}</span>
);

export default function PcAppInstall({ fetchImpl = fetch }) {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchImpl("/api/onto/memo/agent").then((r) => (r.ok ? r.json() : { available: false }))
      .then((j) => { if (alive) setInfo(j); }).catch(() => { if (alive) setInfo({ available: false }); });
    return () => { alive = false; };
  }, [fetchImpl]);

  return (
    <section id="pc" data-testid="pc-app-install" style={{ border: `1px solid ${LINE}`, borderRadius: 12, padding: "18px 20px", marginTop: 24 }}>
      <div style={{ fontSize: 17, fontWeight: 800, color: INK }}>PC 앱 (Windows)</div>
      <ul style={{ fontSize: 13.5, color: BODY, lineHeight: 1.9, margin: "8px 0 0", paddingLeft: 18 }}>
        <li>작업 표시줄 트레이에 늘 떠 있습니다 — 아이콘을 누르면 <b>loginHS 세번분류 화면</b>이 바로 열립니다(주소창 없이 넓게)</li>
        <li><Key>Ctrl</Key>+<Key>Alt</Key>+<Key>H</Key> 어떤 프로그램 위에서든 loginHS 창 · 위쪽 ← → 로 이전·다음 화면</li>
        <li><Key>Ctrl</Key>+<Key>Alt</Key>+<Key>M</Key> 빠른 메모</li>
      </ul>
      <div style={{ marginTop: 14 }}>
        {info === null ? (
          <span style={{ fontSize: 13, color: MUTED }}>확인하는 중…</span>
        ) : info.available ? (
          <a href={info.url} download data-testid="pc-app-download"
            style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "11px 18px", borderRadius: 10, background: BLUE, color: "#fff", fontSize: 14.5, fontWeight: 700, textDecoration: "none" }}>
            내려받기 <span style={{ fontWeight: 400, fontSize: 12.5, opacity: 0.9 }}>Windows · {formatBytes(info.size)}{info.version ? ` · v${info.version}` : ""}</span>
          </a>
        ) : (
          <span style={{ fontSize: 13, color: MUTED }}>설치 파일을 준비하고 있습니다.</span>
        )}
      </div>
      <ol style={{ fontSize: 13, color: BODY, lineHeight: 1.8, margin: "14px 0 0", paddingLeft: 18 }}>
        <li>받은 파일을 실행합니다.</li>
        <li>'Windows의 PC 보호' 창이 뜨면 <b>추가 정보 → 실행</b>을 누릅니다. <span style={{ color: MUTED }}>(코드 서명 준비 중)</span></li>
        <li>열린 loginHS 창에서 처음 한 번 로그인합니다.</li>
        <li>예전 <b>mymemo</b> 앱이 깔려 있으면 <b>설정 › 앱 › 설치된 앱</b>에서 mymemo 를 제거하세요(단축키가 겹칩니다).</li>
      </ol>
    </section>
  );
}
